import {
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  UserLoggedInAction,
  UserLoggedOutAction,
} from '../types/redux/actions';
import { User } from '../types/models/user';
import { AppThunk } from '../store';

export function userLoggedIn(data: User): UserLoggedInAction {
  return {
    type: USER_LOGGED_IN,
    payload: data,
  };
}

export function userLoggedOut(): UserLoggedOutAction {
  return {
    type: USER_LOGGED_OUT,
  };
}

export function loginAction(userInfo: User): AppThunk {
  return (dispatch) => {
    localStorage.setItem('authInfo', JSON.stringify(userInfo));
    dispatch(userLoggedIn(userInfo));
  };
}

export function logoutAction(): AppThunk {
  return (dispatch) => {
    localStorage.removeItem('authInfo');
    dispatch(userLoggedOut());
  };
}
